import {
  StorageItemsPaginationMetaFragment,
  StorageItemFragment,
} from '@sketch/gql-types'
import { removeFromPaginated } from '@sketch/modules-common'
import { DataProxy } from 'apollo-cache'

export interface RemoveFromStorageItemsListProps {
  cache: DataProxy
  target: Pick<StorageItemFragment, '__typename' | 'identifier'>
  filter?: (key: string) => boolean
}

export function removeFromStorageItemsList(
  props: RemoveFromStorageItemsListProps
) {
  const { cache, target, filter }: typeof props = props

  removeFromPaginated(
    cache,
    target,
    key => (key.includes('.storageItems') && filter ? filter(key) : true),
    true,
    pagination => {
      if (!pagination) return

      const maybePagination = pagination as StorageItemsPaginationMetaFragment
      const keys = Object.keys(maybePagination) as Array<
        keyof StorageItemsPaginationMetaFragment
      >

      if (
        target.__typename === 'Project' &&
        keys.includes('nestedProjectsCount')
      ) {
        maybePagination.nestedProjectsCount--
      }
      if (target.__typename === 'Share' && keys.includes('sharesCount')) {
        maybePagination.sharesCount--
      }
    }
  )
}
